import * as _4 from 'lodash4';
import { MajorExplorerCapabilityConfiguration } from '../../configuration';

export class MajorPlacementscoresController {
  private hasPlacementBands: boolean = false;

  constructor(
    private placementTestScores: any,
    private ngMajorExplorerCapabilityConfiguration: MajorExplorerCapabilityConfiguration
  ) {
    const SERVER_PLACEMENT_BAND_STRATEGY = `PlacementBand`;
    this.hasPlacementBands =
      this.ngMajorExplorerCapabilityConfiguration.config.devReqStrategy === SERVER_PLACEMENT_BAND_STRATEGY;
  }

  hasPlacementScores(): boolean {
    return !_4.isEmpty(this.placementTestScores);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/views/major_placement_scores/major_placement_scores_controller.ts